// extracted by mini-css-extract-plugin
export var container = "_25-0";
export var disabled = "_25-4";
export var fullWidth = "_25-3";
export var lined = "_25-1";
export var selected = "_25-5";
export var tab = "_25-2";